// extracted by mini-css-extract-plugin
export default {"STContainer":"style_STContainer__7ryCa","content":"style_content__8extU","vibeBtn":"style_vibeBtn__Y6ET0","imgContainer":"style_imgContainer__yHmG1","cover":"style_cover__AKkWc"};